import { IDcaConfiguration } from "./dcaConfiguration.types"

export class DcaConfiguration implements IDcaConfiguration {
  constructor(
    public name: string,
    public ticketDefinition: string,
  ) {}
}
